"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Storage = /** @class */ (function () {
    function Storage(options) {
        this.prefix = "AB_";
        this.selectedVariantsMap = [];
        if (options && !!options.prefix)
            this.prefix = options.prefix;
    }
    Storage.prototype.add = function (variant) {
        this.selectedVariantsMap.push(variant);
    };
    Storage.prototype.getSaveName = function (experimentName) {
        return "" + this.prefix + experimentName;
    };
    Storage.prototype.getVariant = function (experimentName) {
        var variant = this.selectedVariantsMap.find(function (v) { return v.experimentName == experimentName; });
        return variant;
    };
    return Storage;
}());
exports.Storage = Storage;
//# sourceMappingURL=storage.js.map